import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';


import warehousingJournal from './journal';
import warehousingInventory from './inventory';
import MonthlyReport from './monthly-report';

const System = ({ match }) => (
    <div className="dashboard-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/default`} />
            <Route path={`${match.url}/journal`} component={warehousingJournal} />
            <Route path={`${match.url}/inventory`} component={warehousingInventory} />
            <Route path={`${match.url}/monthly-report`} component={MonthlyReport} />
            <Redirect to="/error" />
        </Switch>
    </div>
);
export default System;
